<template>

  <t-dialog-form :generalErrors="generalErrors" :title="title" :ok-text="okText" @show="showModal" @hidden="resetModal" :id="id" :command="command"
                 ref="dialog_form" @onSubmit="onSubmit">
    <t-input v-model="form.stockPlaceMoldId" :options="stockOptions" first-default :add-error="error.stockPlaceMoldId" label="Estoque de Molde"
             select-common required/>
    <t-input v-model="form.name"  :add-error="error.name" label="Local de Armazenamento" small="Prapeleira, Estante, etc..." submitted focus required/>
  </t-dialog-form>

</template>
<script>
import tDialogForm from "@/components/template/dialog/t-dialog-form";
import pageDialogFormMixin from "@/mixins/page/pageDialogFormMixin";
import StockPlaceMoldService from "@/services/modules/stock/StockPlaceMold.service";

export default {
  name: "StockMoldLocationDialog",
  components: {tDialogForm},
  mixins: [pageDialogFormMixin],
  data() {
    return {
      id: "modal-stock-mold-location",
      title: "Cadastro rápido de Local de Estoque",
      okText: "Incluir Local de Estoque",
      form: {
        stockPlaceMoldId: 0,
        typeMoldId: 0,
        name: "",
        note: "",
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend
        stockPlaceMoldId: "",
        name: "",
      },
      stockOptions: [],
    }
  },
  methods: {

    //Declaro sempre localmente, pois poderá realizar operações diferentes do padrão como setar algum valor padrão vindo de fora e que seria limpo pelo resetModal de forma dinamica
    async showModal() {

      //Limpa os campos
      this.resetModal()

      //Setar alguma informações padrão por exemplo vindo de fora
      await StockPlaceMoldService.selectList("").then((list) => {
        this.stockOptions = list
      }).catch(error => this.responseError(error))


    },

    async onSubmit() {

      //Validações específicas da tela

      const stockName = this.stockOptions.find(x => x.value === this.form.stockPlaceMoldId).text

      await this.setInsertDialog("production/stock-mold-location", (item) => {

        this.itemInserted.value = item.stockPlaceMoldInsideId
        this.itemInserted.text = stockName + ' - ' + this.form.name

        this.successInsert()

      })

    }
  },
  watch:{
    noOptionAdd(){
      this.form.name = this.noOptionAdd
    }
  }

}
</script>
